<p-scrollPanel [style]="{width: '100%', height: '91vh'}">
    <a class="list-group-item list-group-item-action flex-column align-items-start"
        *ngFor="let contact of algoliaContactList" (click)="sendContactDetails(contact)">
        <div class="d-flex w-100 justify-content-between">
            <div style="font-weight: 500; font-size: 14px;" class="mb-0">{{contact.first_name}}
                {{contact.last_name}}</div>
        </div>
    </a>
</p-scrollPanel>